import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import {
  ArrivingFailed,
  ArrivingLayout,
  ArrivingPending,
} from "@/client/components/arriving-layout";
import { pageTitle } from "@/client/lib/page-title";
import { PENDING_MS } from "@/client/lib/pending";
import { sessionQuery } from "@/client/lib/session";
import { InvitesList } from "@/features/identity/components/invites-list";
import { invitationsQuery } from "@/features/identity/invitations-query";

export const Route = createFileRoute("/_authenticated/invites")({
  pendingMs: PENDING_MS,
  pendingComponent: ArrivingPending,
  errorComponent: ArrivingFailed,
  head: async () => {
    const { identityCopy } = await import("@/features/identity/copy");
    return { meta: [{ title: pageTitle(identityCopy.invites.title) }] };
  },
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(invitationsQuery),
  component: Invites,
});

function Invites() {
  const { data } = useSuspenseQuery(invitationsQuery);
  const { data: session } = useSuspenseQuery(sessionQuery);
  return (
    <ArrivingLayout>
      <InvitesList invitations={data} email={session.email ?? ""} />
    </ArrivingLayout>
  );
}
